<div class="w-full h-full justify-center items-center flex flex-col">
	<atomic-loading-icon></atomic-loading-icon>
	<p class="mt-2 text-gray-700 text-center mr-16">Connecting to Outlook...</p>
</div>
<!-- <div>Outlook Callback</div>
<div *ngIf="state === states.loginError" [@openClose]>
	<atomic-message-bar class="my-10">
		Unable to get a token from Outlook. Please try logging in again
	</atomic-message-bar>
</div>

<div
	*ngIf="state === states.savingAuth || state === states.savedSuccess"
	class="flex flex-col justify-center items-center"
>
	<div class="flex gap-4" *ngIf="state === states.savingAuth">
		<app-icon [spin]="true" [icon]="ICON.LOADING"></app-icon>
		<p>Storing auth credentials</p>
	</div>
	<div
		class="flex flex-col justify-center items-center"
		*ngIf="state === states.savedSuccess"
	>
		<div class="flex gap-4">
			<app-icon
				size="xlarge"
				class="text-green"
				[icon]="ICON.SUCCESS"
			></app-icon>
			<p>Credentials successfully saved!</p>
		</div>
	</div>
</div> -->
